module.exports = {
    amcBaseUrl: "https://accounts.myntra.com/",
    amcClientId: "myntra-swagger-49472439-e658-41f2-93c7-1d2cc36befa5" //PROD

   // amcBaseUrl: "https://accounts.stage.myntra.com/",
   // amcClientId: "myntra-swagger-7f9ec6f9-a332-41cd-a4ea-dbe84b1c713f" //STAGE
}